import React from "react";
import { print } from "graphql";
import { auth0, impersonation } from "@pga/auth-flow-provider";
import { LoadingComponent } from "@pga/pga-component-library";
import { getMeUser } from "../queries";

const {
  getImpersonationHeader,
  shouldDisableAnalytics,
  resetAnalyticsState,
  ImpersonationOverlay,
  isImpersonating,
} = impersonation;

const {
  AuthFlowProvider,
  PrivateRoute,
  RedirectToLogin,
  RedirectToLogout,
  redirectToLogout,
  withAuthProvider,
  getToken,
} = auth0;

const fetchCurrentUser = async (token) => {
  try {
    if (!token) {
      return [null, new Error("No authentication token provided")];
    }

    const res = await fetch(process.env.REACT_APP_V3_API_HOST, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "X-Client-Name": "jobs-pga-org",
        ...getImpersonationHeader(),
      },
      body: JSON.stringify({ query: print(getMeUser) }),
    });

    const json = await res.json();
    const currentUser = json && json.data && json.data.me;
    if (!currentUser) {
      throw new Error("No user found");
    }
    return [currentUser, null];
  } catch (err) {
    return [null, err];
  }
};

const renderRedirecting = () => <LoadingComponent />;

const AuthProvider = ({ children }) => (
  <AuthFlowProvider
    fetchCurrentUser={fetchCurrentUser}
    renderRedirecting={renderRedirecting}
  >
    {children}
  </AuthFlowProvider>
);

const setToken = (_) => {};

export {
  AuthProvider,
  PrivateRoute,
  RedirectToLogin,
  RedirectToLogout,
  redirectToLogout,
  withAuthProvider,
  getToken,
  setToken,
  getImpersonationHeader,
  shouldDisableAnalytics,
  resetAnalyticsState,
  ImpersonationOverlay,
  isImpersonating,
};
